export interface BusinessCenterTab {
  id: string;
  name: string;
  icon: string;
  version?: string;
}

export const DASHBOARD_TAB = 'dashboard';
export const REPUTATION_TAB = 'reputation';
export const SOCIAL_TAB = 'social';
export const CUSTOMER_VOICE_TAB = 'customer_voice';
export const RECENT_ACTIVITY_TAB = 'recent_activity';
export const RECOMMENDATIONS_TAB = 'lmi_dashboard';
export const STORE_TAB = 'store';
export const CUSTOMER_LIST_TAB = 'customer_list';
export const EXECUTIVE_REPORT_TAB = 'executive_report';
export const GUIDES_TAB = 'content_library';
export const FILES_TAB = 'files';
export const BUSINESS_PROFILE_TAB = 'business_profile';
export const SOCIAL_CONNECTIONS_TAB = 'social_connections';
export const MY_PRODUCTS_TAB = 'my_products';
export const INVOICES_TAB = 'invoices';
export const GET_STARTED_TAB = 'get_started';
export const NEW_INBOX_TAB = 'new_inbox';
export const MEETING_SCHEDULER_TAB = 'meeting_scheduler';
export const ORDERS_TAB = 'orders';
export const PROJECTS_TAB = 'fulfillment';
export const CONTACTS_BUTTON = 'contacts_button';

export const businessNavTabList: BusinessCenterTab[] = [
  {
    id: REPUTATION_TAB,
    name: 'Reputation',
    icon: 'star_rate',
  },
  {
    id: SOCIAL_TAB,
    name: 'Social',
    icon: 'forum',
  },
  {
    id: CUSTOMER_VOICE_TAB,
    name: 'Customer Voice',
    icon: 'rate_review',
  },
];

/**
 * A list of all the available tabs in Business App. This is the set of tabs
 * which can be toggled on and off for a user.
 */
export const businessCenterTabList: BusinessCenterTab[] = [
  {
    id: GET_STARTED_TAB,
    name: 'Get Started',
    icon: 'local_library',
  },
  {
    id: DASHBOARD_TAB,
    name: 'Dashboard',
    icon: 'dashboard',
  },
  {
    id: RECENT_ACTIVITY_TAB,
    name: 'Recent Activity',
    icon: 'history',
  },
  {
    id: NEW_INBOX_TAB,
    name: 'Inbox Messages',
    icon: 'question_answer',
  },
  {
    id: CUSTOMER_LIST_TAB,
    name: 'Customers',
    icon: 'person',
  },
  {
    id: MEETING_SCHEDULER_TAB,
    name: 'My Meetings',
    icon: 'event',
  },
  {
    id: RECOMMENDATIONS_TAB,
    name: 'Recommendations',
    icon: 'speaker_notes',
  },
  {
    id: STORE_TAB,
    name: 'Store',
    icon: 'shopping_basket',
  },
  {
    id: EXECUTIVE_REPORT_TAB,
    name: 'Executive Report',
    icon: 'timeline',
  },
  {
    id: GUIDES_TAB,
    name: 'Guides',
    icon: 'library_books',
  },
  {
    id: FILES_TAB,
    name: 'Files',
    icon: 'insert_drive_file',
  },
  {
    id: BUSINESS_PROFILE_TAB,
    name: 'Business Profile',
    icon: 'account_box',
  },
  {
    id: SOCIAL_CONNECTIONS_TAB,
    name: 'Social Connections',
    icon: 'device_hub',
  },
  {
    id: ORDERS_TAB,
    name: 'Orders',
    icon: 'list_alt',
  },
  {
    id: PROJECTS_TAB,
    name: 'Projects',
    icon: 'timelapse',
  },
  {
    id: INVOICES_TAB,
    name: 'Invoices',
    icon: 'attach_money',
  },
  {
    id: MY_PRODUCTS_TAB,
    name: 'My Products',
    icon: 'apps',
  },
];
